import React, { useState, useEffect } from 'react';
import { getWmsClientes, createWmsCliente, updateWmsCliente, deleteWmsCliente } from '../../api.wms.clientes';

const initialCliente = {
  nombre: '', razon_social: '', rfc: '', direccion: '', ciudad: '', estado: '', pais: '', codigo_postal: '', telefono: '', email: '', contacto: '', activo: true, observaciones: ''
};

const ClientesManagement = () => {
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [clienteForm, setClienteForm] = useState(initialCliente);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [notification, setNotification] = useState(null);

  useEffect(() => { fetchClientes(); }, []);

  const fetchClientes = async () => {
    setLoading(true);
    try { setClientes(await getWmsClientes()); } catch { setClientes([]); }
    setLoading(false);
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      if (selectedCliente) {
        await updateWmsCliente(selectedCliente.id, clienteForm);
        setNotification({ type: 'success', message: 'Cliente actualizado' });
      } else {
        await createWmsCliente(clienteForm);
        setNotification({ type: 'success', message: 'Cliente creado' });
      }
      fetchClientes();
    } catch {
      setNotification({ type: 'error', message: 'Error al guardar cliente' });
    }
    setShowModal(false);
    setSelectedCliente(null);
    setClienteForm(initialCliente);
    setLoading(false);
  };

  const handleDelete = async (cliente) => {
    if (!window.confirm('¿Eliminar cliente?')) return;
    setLoading(true);
    try {
      await deleteWmsCliente(cliente.id);
      setNotification({ type: 'success', message: 'Cliente eliminado' });
      fetchClientes();
    } catch {
      setNotification({ type: 'error', message: 'Error al eliminar cliente' });
    }
    setLoading(false);
  };

  const openEdit = (cliente) => {
    setSelectedCliente(cliente);
    setClienteForm({ ...cliente });
    setShowModal(true);
  };

  const openNew = () => {
    setSelectedCliente(null);
    setClienteForm(initialCliente);
    setShowModal(true);
  };

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-gray-800">Gestión de Clientes</h2>
        <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded shadow font-semibold" onClick={openNew}>Nuevo cliente</button>
      </div>
      <div className="overflow-x-auto rounded-lg shadow">
        <table className="min-w-full bg-white text-sm">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="px-2 py-2">ID</th>
              <th className="px-2 py-2">Nombre</th>
              <th className="px-2 py-2">Razón social</th>
              <th className="px-2 py-2">RFC</th>
              <th className="px-2 py-2">Dirección</th>
              <th className="px-2 py-2">Ciudad</th>
              <th className="px-2 py-2">Estado</th>
              <th className="px-2 py-2">País</th>
              <th className="px-2 py-2">CP</th>
              <th className="px-2 py-2">Teléfono</th>
              <th className="px-2 py-2">Email</th>
              <th className="px-2 py-2">Contacto</th>
              <th className="px-2 py-2">Activo</th>
              <th className="px-2 py-2">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {clientes.map(c => (
              <tr key={c.id} className="border-b hover:bg-gray-50">
                <td className="px-2 py-1">{c.id}</td>
                <td className="px-2 py-1 font-semibold">{c.nombre}</td>
                <td className="px-2 py-1">{c.razon_social}</td>
                <td className="px-2 py-1">{c.rfc}</td>
                <td className="px-2 py-1">{c.direccion}</td>
                <td className="px-2 py-1">{c.ciudad}</td>
                <td className="px-2 py-1">{c.estado}</td>
                <td className="px-2 py-1">{c.pais}</td>
                <td className="px-2 py-1">{c.codigo_postal}</td>
                <td className="px-2 py-1">{c.telefono}</td>
                <td className="px-2 py-1">{c.email}</td>
                <td className="px-2 py-1">{c.contacto}</td>
                <td className="px-2 py-1">{c.activo ? 'Sí' : 'No'}</td>
                <td className="px-2 py-1">
                  <button className="text-blue-700 hover:underline mr-2" onClick={() => openEdit(c)}>Editar</button>
                  <button className="text-red-600 hover:underline" onClick={() => handleDelete(c)}>Eliminar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Modal de edición/creación */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-2xl">
            <h3 className="text-xl font-bold mb-4 text-gray-800">{selectedCliente ? 'Editar cliente' : 'Nuevo cliente'}</h3>
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input className="border rounded px-3 py-2" placeholder="Nombre*" value={clienteForm.nombre} onChange={e => setClienteForm(f => ({...f, nombre: e.target.value}))} required />
              <input className="border rounded px-3 py-2" placeholder="Razón social" value={clienteForm.razon_social} onChange={e => setClienteForm(f => ({...f, razon_social: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="RFC" value={clienteForm.rfc} onChange={e => setClienteForm(f => ({...f, rfc: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="Dirección" value={clienteForm.direccion} onChange={e => setClienteForm(f => ({...f, direccion: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="Ciudad" value={clienteForm.ciudad} onChange={e => setClienteForm(f => ({...f, ciudad: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="Estado" value={clienteForm.estado} onChange={e => setClienteForm(f => ({...f, estado: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="País" value={clienteForm.pais} onChange={e => setClienteForm(f => ({...f, pais: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="Código postal" value={clienteForm.codigo_postal} onChange={e => setClienteForm(f => ({...f, codigo_postal: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="Teléfono" value={clienteForm.telefono} onChange={e => setClienteForm(f => ({...f, telefono: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="Email" value={clienteForm.email} onChange={e => setClienteForm(f => ({...f, email: e.target.value}))} />
              <input className="border rounded px-3 py-2" placeholder="Contacto" value={clienteForm.contacto} onChange={e => setClienteForm(f => ({...f, contacto: e.target.value}))} />
              <div className="flex items-center gap-2 col-span-2">
                <input type="checkbox" checked={clienteForm.activo} onChange={e => setClienteForm(f => ({...f, activo: e.target.checked}))} id="activo" />
                <label htmlFor="activo">Activo</label>
              </div>
              <textarea className="border rounded px-3 py-2 col-span-2" placeholder="Observaciones" value={clienteForm.observaciones} onChange={e => setClienteForm(f => ({...f, observaciones: e.target.value}))} />
            </form>
            <div className="flex justify-end mt-6 gap-2">
              <button className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded" onClick={() => { setShowModal(false); setSelectedCliente(null); setClienteForm(initialCliente); }}>Cancelar</button>
              <button className="bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded font-semibold" onClick={handleSave} disabled={loading}>{selectedCliente ? 'Actualizar' : 'Crear'}</button>
            </div>
          </div>
        </div>
      )}
      {notification && (
        <div className={`mt-4 p-2 rounded ${notification.type === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>{notification.message}</div>
      )}
    </div>
  );
};

export default ClientesManagement;
